import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {merchantsList_template} from "../components/templates/merchantsList_template";

declare var ko: any;
declare var page: any;

export class merchants extends vnModule_knockoutJS {

    protected merchantsListTemplate: merchantsList_template;
    protected timer;

    protected getModuleName(): string {
        return "merchants";
    }

    buildContent(): Element[] {
        this.merchantsListTemplate = new merchantsList_template("list", this.viewModel, this);
        this.template = this.merchantsListTemplate;

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (loadedModule as header).setHeaderTitle("Merchants List");

        return [this.merchantsListTemplate.build()];
    }

    public fillPage(): void {
        this.getReferences();
        this.getListFormData();
    }

    protected getReferences(): void {
        const self = this;
        const idBrand = this.getVnAppZone().app.params.idBrand;

        // Get categories for filter
        if (this.XHRHdls['categories']) {
            this.XHRHdls['categories'].cancelAndReset();
        }

        const catUrl = '/api/discounts/categories/tree/';
        const catParams: string[][] = [];
        catParams.push(["data", ko.toJSON({ brandId: idBrand })]);
        this.XHRHdls['categories'] = new XMLHttpRequestHandler(catUrl, catParams, this);
        this.XHRHdls['categories'].onReadyStateFunction = this.onGetCategoriesReturn;
        this.XHRHdls['categories'].execute();
    }

    protected onGetCategoriesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                if (response.categories) {
                    const flatCategories = obj.flattenCategories(response.categories);
                    obj.merchantsListTemplate.setCategoryOptions(flatCategories);
                } else if (Array.isArray(response)) {
                    const flatCategories = obj.flattenCategories(response);
                    obj.merchantsListTemplate.setCategoryOptions(flatCategories);
                }
            });
        };
    }

    protected flattenCategories(categories: any[], parentName: string = ''): any[] {
        let flat: any[] = [];
        for (const cat of categories) {
            const displayName = parentName ? `${parentName} > ${cat.name}` : cat.name;
            flat.push({ id: cat.id, name: displayName });
            if (cat.children && cat.children.length > 0) {
                flat = flat.concat(this.flattenCategories(cat.children, displayName));
            }
        }
        return flat;
    }

    public getListFormData(): void {
        if (this.XHRHdls['merchants']) {
            this.XHRHdls['merchants'].cancelAndReset();
        }
        this.loadingIn(this.merchantsListTemplate.builtTemplate.children.namedItem("list-results"));

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/merchants/get/';
        const usrReq_params: string[][] = [];

        usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);
        this.XHRHdls['merchants'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['merchants'].onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdls['merchants'].execute();
    }

    protected onListFormDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                obj.merchantsListTemplate.setListData(response.merchants || response.data || []);

                const execTime = Math.round((new Date().getTime() - obj.XHRHdls['merchants'].requestStartTime) / 1000 * 100) / 100;
                obj.merchantsListTemplate.setResultInfo(
                    response.totalCount || (response.merchants ? response.merchants.length : (response.data ? response.data.length : 0)),
                    response.totalPage || 1,
                    execTime
                );
            });

            obj.loadingOut(obj.merchantsListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    public filterList(): void {
        if (this.XHRHdls['merchants']) {
            this.XHRHdls['merchants'].cancelAndReset();
        }

        this.loadingIn(this.merchantsListTemplate.builtTemplate.children.namedItem("list-results"));

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/merchants/get/';
        this.timer = new Date().getTime();

        const subViewModel: any = this.merchantsListTemplate.getViewModelForRequest();
        subViewModel.brandId = idBrand;

        this.sendFilterCall(
            usrReq_url,
            subViewModel,
            this.onFilterRequestReturn,
            XMLHttpRequestHandler_requestType.GET,
            'merchants',
            this.merchantsListTemplate.builtTemplate.children.namedItem("list-results")
        );
    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.merchantsListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected updateList(response: any): void {
        this.merchantsListTemplate.setListData(response.merchants || response.data || []);
        const execTime = Math.round((new Date().getTime() - this.timer) / 1000 * 100) / 100;
        this.merchantsListTemplate.setResultInfo(
            response.totalCount || (response.merchants ? response.merchants.length : (response.data ? response.data.length : 0)),
            response.totalPage || 1,
            execTime
        );
    }

    protected add() {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/merchants/add/');
    }

    protected viewMerchant(id: number): void {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/merchants/view/' + id + '/');
    }

    protected editMerchant(id: number): void {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/merchants/edit/' + id + '/');
    }

    protected delete(id: number): void {
        if (this.XHRHdls['delete-merchant']) {
            this.XHRHdls['delete-merchant'].cancelAndReset();
        }

        this.loadingIn(this.merchantsListTemplate.builtTemplate.children.namedItem("list-results"));

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/merchants/delete/' + id + '/';
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);

        this.XHRHdls['delete-merchant'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['delete-merchant'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['delete-merchant'].onReadyStateFunction = this.onDeleteMerchantReturn;
        this.XHRHdls['delete-merchant'].execute();
    }

    protected onDeleteMerchantReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.filterList();
            });
            obj.loadingOut(obj.merchantsListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected filterSimpleOnChange(idElement) {
        this.merchantsListTemplate.setPageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdls['merchants']) {
            (this.XHRHdls['merchants'] as XMLHttpRequestHandler).cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(idElement) {
        this.merchantsListTemplate.setPageNumber(1);
        this.filterList();
    }
}



// WEBPACK FOOTER //
// ./js/modules/merchants.ts